<template>
  <!--================ banner =================-->
  <section v-if="bannerTopo != ''" class="breadcrumb_area">
    <div class="overlay bg-parallax">
      <img :src="$imagens + 'about_banner.jpg'" alt="">
    </div>
    <div class="container">
      <div class="page-cover text-center">
        <h2 class="page-cover-tittle">{{ bannerTopo[0].itiNome }}</h2>
        <ol class="breadcrumb">
          <li><router-link to="/">Home / </router-link></li>
          <li>{{ bannerTopo[0].itiNome }}</li>
        </ol>
      </div>
    </div>
  </section>

  <!--================ pagina informações  =================-->
  <section class="about_history_area section_gap">
    <div class="container">

      <section>
        <div class="services-area2 section-padding-info">
          <div class="container">
            <div class="row">
              <!--=== menu ==========-->
              <div class="col-lg-3 col-md-6 col-sm-8 order-lg-1">
                <div class="filter-widget">
                  <ul class="filter-catagories">
                    <li v-for="(menu, menuIndex) in informacoes" :key="menuIndex">
                      <a href="#" @click.prevent="carregaTexto(menu.itiId)">{{ menu.itiNome }}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <!--=== textos ==========-->
              <div v-if="informacao != ''" class="col-lg-9 order-lg-2 titulo-informacao pl-30">
                <h3>{{ informacao[0].itiNome }}</h3><br>
                <p v-html="informacao[0].itiResumo1"></p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </div>
  </section>
  
</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';
import { useRoute } from 'vue-router';

export default {
  name: 'InformacoesView',
  components: {
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    informacoes: [],
    informacao: [],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },
    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Garante Imob - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Garante Imob" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
          { name: "keywords", content: "" }
        ],
      })
    },

    carregaTexto(value) {
  this.informacao = this.informacoes.filter(x => x.itiId == value)

  if (this.informacao.length) {
    const titulo = this.informacao[0].itiNome
    const texto = this.removerTagsHTML(this.informacao[0].itiResumo1)

    this.carregaMetas(texto, titulo)
  }
}
  },

  created() {
    this.carregaMetas();

    axios.get('/Process/InsInstitucional/institucional/53/topoinformacoes/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('bannerTopo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    axios.get('/Process/InsInstitucional/institucional/54/listadasinformacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);

        if (this.id) {
          this.carregaTexto(this.id);
        }
        else {
          this.carregaTexto(this.informacoes[0].itiId);
        }

      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>